// import { getAuth, signOut } from "firebase/auth";
// import router from "@/router";
import { db } from "@/firebase";
import {
  doc,
  getDoc,
  collection,
  getDocs,
  deleteDoc,
  updateDoc,
  arrayRemove,
} from "firebase/firestore";
import { httpsCallable } from "firebase/functions";
import { functions } from "@/firebase";
import { DateTime } from "luxon";

const schedules = {
  state: {
    schedules: [],
    queue: [],
    calendar: [],
    week: 0,
    window: 0,
    week_day: null,
    month: "",
    year: "",
    cursor: null,
    end_of_calendar: false,
  },
  mutations: {
    setSchedules(state, val) {
      state.schedules = val;
    },
    setQueue(state, val) {
      state.queue = val;
    },
    setCalendar(state, val) {
      state.calendar = val;
    },
    addCalendar(state, val) {
      state.calendar = [...state.calendar, ...val];
    },
    setCursor(state, val) {
      state.cursor = val;
    },
    setEndOfCalendar(state, val) {
      state.end_of_calendar = val;
    },
    setWeek(state, val) {
      state.week = val;
    },
    setMonth(state, val) {
      state.month = val;
    },
    nextWeek(state) {
      if (state.window < state.calendar.length) {
        let next = state.week_day.plus({ week: 1 });
        state.week_day = next;
        state.week = next.weekNumber;
        state.window = state.window + 1;
        state.month = next.toFormat("LLLL");
        state.year = next.year;
      }
    },
    previousWeek(state) {
      if (state.window > 0) {
        let previous = state.week_day.minus({ week: 1 });
        state.week_day = previous;
        state.week = previous.weekNumber;
        state.window = state.window - 1;
        state.month = previous.toFormat("LLLL");
        state.year = previous.year;
      }
    },
    today(state) {
      const i = state.calendar.findIndex(
        (w) => w.week === DateTime.now().weekNumber,
      );
      state.month = DateTime.now().toFormat("LLLL");
      state.week_day = DateTime.now();
      state.year = DateTime.now().year;
      state.window = i;
    },
  },
  actions: {
    async updateSkip(
      { dispatch, rootState },
      { calendar_uid, post_uid, skip },
    ) {
      console.log(
        "Updating skip for post: " +
          post_uid +
          " to " +
          skip +
          " on calendar: " +
          calendar_uid,
      );
      await updateDoc(
        doc(
          db,
          "calendar",
          calendar_uid,
          rootState.users.userProfile.workspace,
          post_uid,
        ),
        { skip },
      );
      const slotDoc = await getDoc(
        doc(
          db,
          "calendar",
          calendar_uid,
          rootState.users.userProfile.workspace,
          post_uid,
        ),
      );
      const category = slotDoc.data().category;
      const skipSlot = httpsCallable(functions, "skipSlot");
      await skipSlot({
        category: category,
      });
      await new Promise((resolve) => setTimeout(resolve, 1000));
      dispatch("getCalendarDays");
      return 200;
    },
    async deleteSchedule({ rootState, dispatch }, uid) {
      await deleteDoc(
        doc(
          db,
          "workspaces",
          rootState.users.userProfile.workspace,
          "schedules",
          uid,
        ),
      );
      let c = rootState.posts.categories.find((c) => c.schedules.includes(uid));
      if (c != undefined) {
        let i = c.schedules.findIndex((s) => s === uid);
        c.schedules.splice(i, 1);
        const categoryDocRef = doc(
          db,
          "workspaces",
          rootState.users.userProfile.workspace,
          "categories",
          c.uid,
        );
        await updateDoc(categoryDocRef, {
          schedules: arrayRemove(uid),
        });
      }

      dispatch("fetchSchedules");
      dispatch("fetchCategories");
    },
    async updateSchedule({ commit, rootState, state }, { uid, active }) {
      await updateDoc(
        doc(
          db,
          "workspaces",
          rootState.users.userProfile.workspace,
          "schedules",
          uid,
        ),
        { active },
      );
      commit(
        "setSchedules",
        state.schedules.map((s) => (s.uid === uid ? { ...s, active } : s)),
      );
    },
    async getCalendarDays({ commit, state }) {
      let cursorBefore = state.cursor;
      let loadingType = cursorBefore ? "calendar_next" : "calendar";

      commit("setLoading", { type: loadingType, val: true });

      if (state.end_of_calendar) {
        // commit("setNotification", {
        //   show: true,
        //   text: "No more days to load",
        //   type: "error",
        //   icon: "",
        // });
        commit("setLoading", { type: loadingType, val: false });
        return;
      }
      const getCalendar = httpsCallable(functions, "calenderGet");
      const res = await getCalendar({ cursor: state.cursor });
      console.log("res", res.data);
      if (res.data.length === 0) {
        commit("setLoading", { type: loadingType, val: false });
        commit("setEndOfCalendar", true);
        return;
      }
      let lastWeekDays = res.data[res.data.length - 1].days;
      let lastDay = lastWeekDays[lastWeekDays.length - 1];
      console.log("lastDay", lastDay);

      commit("setCursor", lastDay.unix);

      if (!cursorBefore) {
        commit("setCalendar", res.data);
        commit("today");
      } else {
        commit("addCalendar", res.data);
      }
      commit("setLoading", { type: loadingType, val: false });
      console.log("finished loading calendar");
    },
    async fetchSchedules({ commit, rootState }) {
      commit("setLoading", { type: "schedules", val: true });
      let schedules = [];

      const querySnapshot = await getDocs(
        collection(
          db,
          "workspaces",
          rootState.users.userProfile.workspace,
          "schedules",
        ),
      );
      await Promise.all(
        querySnapshot.docs.map(async (d) => {
          let schedule = d.data();
          const docRef = doc(
            db,
            "workspaces",
            rootState.users.userProfile.workspace,
            "categories",
            schedule.category,
          );
          const docSnap = await getDoc(docRef);

          if (docSnap.exists()) {
            schedule.category = docSnap.data();
          } else {
            console.log("No such document!");
          }

          schedules.push(schedule);
        }),
      );

      commit("setSchedules", schedules);
      commit("setLoading", { type: "schedules", val: false });
    },
  },
  getters: {},
};

export default schedules;
